import { render, staticRenderFns } from "./daka_bzr.vue?vue&type=template&id=1929a2c8"
import script from "./daka_bzr.vue?vue&type=script&lang=js"
export * from "./daka_bzr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports